import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rules-terms',
  templateUrl: './rules-terms.component.html',
  styleUrls: ['./rules-terms.component.scss']
})
export class RulesTermsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
